import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TokenResponseType } from "../../../types/TokenResponse";

const initialState: { token: string, userData: TokenResponseType } = {
    token: '',
    userData: {
        Username: "",
        UserId: "",
        Fullname: "",
        Email: "",
        Role: [],
        Permission: [],
        exp: 0,
        iss: "",
        aud: ""
    }
};

export const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload
        },
        setUserData: (state, action: PayloadAction<TokenResponseType>) => {
            state.userData = action.payload
        }
    }
});
export const { setToken, setUserData } = loginSlice.actions;
export default loginSlice.reducer;